// 留言管理 — M8 已切真后端（comments 表，mp_comment scraper 入库后才有数据）
// 后端 schema: app/schemas/comment.py
//   articleTitle 可能为空（留言对应的文章未抓取到）；nickname 后端兜底为 "(匿名)"，但 schema 允许 null
import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'

export type CommentStatus = 'elected' | 'normal' | 'pending'

export interface CommentItem {
  id: number
  commentId: string
  articleId: number | null
  articleTitle: string
  openid: string | null
  nickname: string | null
  avatarUrl: string | null
  content: string
  createTime: number
  status: CommentStatus
  isTop: boolean
  replyContent: string | null
  followDuration: number
  commentCount: number
}

export interface UseCommentListParams {
  status?: CommentStatus | 'all'
  search?: string
  articleId?: number | null
}

interface CommentListResponse {
  items: CommentItem[]
  total: number
  page: number
  pageSize: number
}

export function useCommentList(params: UseCommentListParams = {}) {
  return useQuery({
    queryKey: ['comments', 'list', params],
    queryFn: async () => {
      const qp = new URLSearchParams()
      qp.set('page', '1')
      qp.set('page_size', '50')
      if (params.status && params.status !== 'all') qp.set('status', params.status)
      if (params.search?.trim()) qp.set('search', params.search.trim())
      if (params.articleId != null) qp.set('article_id', String(params.articleId))
      const resp = await get<CommentListResponse>(`/comments?${qp.toString()}`)
      return resp.items
    },
  })
}
